import React, { useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import Slider from "../components/Slider";
import TopBanner from "../components/TopBanner";

const Projects = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const constainerVariant = {
    hidden: {
      scaleX: 0,
    },
    visible: {
      scaleX: 1,
      transition: { type: "spring", stiffness: 50 },
    },
    exit: {
      scaleX: 0,
      transition: { ease: "easeInOut" },
    },
  };

  return (
    <>
      <motion.div
        variants={constainerVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <Container>
          <TopBanner
            loaction1={"Currently"}
            location2={"Frontend Developer"}
            place1={"Based in Abuja"}
            place2={"Nigeria"}
          />

          <Main>
            <Sec1>
              <ProjectHeading>
                <h1>projects</h1>
                <p>A selected set of projects i've built.</p>
              </ProjectHeading>

              <ProjectContainer>
                <Project>
                  <Slider />
                </Project>
              </ProjectContainer>
            </Sec1>
          </Main>
        </Container>
      </motion.div>
    </>
  );
};

export default Projects;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
`;

const Main = styled.main`
  width: 100%;
  min-height: 100vh;
`;

const Sec1 = styled.section`
  width: 100%;
`;
const ProjectHeading = styled.section`
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;

  h1 {
    font-size: 80px;
    text-transform: uppercase;
    letter-spacing: 5px;
    z-index: 1;
  }

  p {
    font-size: 25px;
    z-index: 1;
  }

  @media screen and (max-width: 760px) {
    h1 {
      font-size: 40px;
    }
    p {
      font-size: 20px;
    }
  }
`;
const ProjectContainer = styled.section`
  width: 100%;

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: black;

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Project = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  margin: 5rem 0;

  p {
    font-size: 22px;
  }

  @media screen and (max-width: 760px) {
    display: block;

    p {
      font-size: 20px;
    }
  }
`;
